// extracted by mini-css-extract-plugin
export var border = "_1s-8";
export var brand = "_1s-t";
export var button = "_1s-l";
export var center = "_1s-a";
export var centered = "_1s-6";
export var closeButton = "_1s-c";
export var disabledWrapper = "_1s-m";
export var error = "_1s-p";
export var extraLarge = "_1s-4";
export var extraSmall = "_1s-1";
export var fill = "_1s-i";
export var footer = "_1s-h";
export var footerAction = "_1s-j";
export var footerButtons = "_1s-k";
export var header = "_1s-7";
export var headerWithClose = "_1s-d";
export var icon = "_1s-o";
export var info = "_1s-s";
export var inline = "_1s-9";
export var large = "_1s-3";
export var main = "_1s-e";
export var modal = "_1s-0";
export var nearFull = "_1s-5";
export var neutral = "_1s-u";
export var noPadding = "_1s-g";
export var none = "_1s-v";
export var scrollable = "_1s-f";
export var small = "_1s-2";
export var success = "_1s-r";
export var tight = "_1s-n";
export var titleIcon = "_1s-b";
export var warn = "_1s-q";